import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {PipeLibraryModule} from '../../pipes/pipe-library.module';
import {AngularMaterialLibraryModule} from '../../angular-material/angular-material-library.module';
import {DirectiveLibraryModule} from '../../directives/directive-library.module';
import {CollapsableExpandableTextComponent} from './collapsable-expandable-text.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        PipeLibraryModule,
        AngularMaterialLibraryModule,
        DirectiveLibraryModule,
        CollapsableExpandableTextComponent
    ],
    exports: [
        CollapsableExpandableTextComponent,
    ]
})
export class CollapsableExpandableTextModule {

}
